

export default {
    setConfig: (state: any, payload: string): void => {
        state.setting = payload;
    },
    setDefault: (state: any, payload: string): void => {
        state.default = payload;
    }
};
